module.exports = __webpack_public_path__ + "img/4-2_Node_Info.bf5cfd2b.png";